import { render, staticRenderFns } from "./VProgressCircular.vue?vue&type=template&id=2efea901&scoped=true&"
import script from "./VProgressCircular.vue?vue&type=script&lang=js&"
export * from "./VProgressCircular.vue?vue&type=script&lang=js&"
import style0 from "./VProgressCircular.vue?vue&type=style&index=0&id=2efea901&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efea901",
  null
  
)

export default component.exports